<script setup>
defineProps({
    projectSlug: { type: String, default: '#' }
})
</script>
<template>
    <div class="right d-flex align-center justify-end">
        <v-btn value="top-right-links" variant="text" :href="`/${projectSlug}/compare`">
            <v-icon class="d-inline d-md-none">mdi-star-outline</v-icon>
            <span class="d-none d-md-inline text-capitalize">{{ $t('compare') }}</span>
        </v-btn>
        <ClientOnly>
            <v-btn v-if="$auth.authenticated" value="top-right-links" variant="text">
                <v-icon>mdi-account-outline</v-icon>
                <span class="text-capitalize ml-1">{{ $auth.tokenParsed.given_name }}</span>
                <v-menu activator="parent">
                    <v-list>
                        <v-list-item>
                            <v-list-item-title>
                                <a
                                    :href="`${$auth.tokenParsed.iss}/account`"
                                    class="text-decoration-none"
                                    >{{ $t('account') }}</a
                                >
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-title @click="$auth.logout()" class="cursor-pointer">
                                {{ $t('logout') }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-btn>
            <v-btn v-else value="top-right-links" variant="text" @click="$auth.login()">
                <v-icon class="d-inline d-md-none">mdi-account-outline</v-icon>
                <span class="d-none d-md-inline text-capitalize">{{ $t('login') }}</span>
            </v-btn>
        </ClientOnly>
    </div>
</template>
